var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgObjectBusMinor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 57,
    viewBox: "0 0 56 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.88013,
    width: 53,
    height: 53,
    rx: 6.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.88013,
    width: 53,
    height: 53,
    rx: 6.5,
    stroke: "#0089EC",
    strokeWidth: 3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.9749 38.4968H21.2583V36.5635H24.9749V38.4968ZM34.7416 36.5635H31.0749V38.4968H34.7416V36.5635ZM41.7916 21.9135V29.2801H39.8082V23.8468H38.1416V39.9801C38.1409 40.3841 38.0264 40.7798 37.8112 41.1217C37.5961 41.4637 37.2889 41.7381 36.9249 41.9135V43.3801H32.5082V42.1635H23.4583V43.3801H19.0749V41.9135C18.7134 41.735 18.4083 41.4598 18.1936 41.1186C17.9788 40.7774 17.8628 40.3833 17.8583 39.9801V23.8468H16.1916V29.2801H14.2083V21.9135H17.8583V18.5801C17.8714 17.1993 18.428 15.8793 19.4076 14.9059C20.3871 13.9326 21.7107 13.3844 23.0916 13.3801H32.8582C34.2462 13.3801 35.5773 13.9315 36.5588 14.9129C37.5402 15.8944 38.0916 17.2255 38.0916 18.6135V21.9468H41.7416L41.7916 21.9135ZM36.2082 33.5801H19.7916V39.9468C19.7916 40.0131 19.8179 40.0767 19.8648 40.1236C19.9117 40.1705 19.9753 40.1968 20.0416 40.1968H35.9082C35.9746 40.1968 36.0381 40.1705 36.085 40.1236C36.1319 40.0767 36.1582 40.0131 36.1582 39.9468L36.2082 33.5801ZM36.2082 22.5968H19.7916V31.6468H36.1582L36.2082 22.5968ZM36.2082 18.5801C36.2082 17.6961 35.8571 16.8482 35.2319 16.2231C34.6068 15.598 33.759 15.2468 32.8749 15.2468H23.0916C22.2075 15.2468 21.3597 15.598 20.7346 16.2231C20.1094 16.8482 19.7583 17.6961 19.7583 18.5801V20.6968H36.1249L36.2082 18.5801ZM24.3083 19.0801H31.6416V17.1468H24.3083V19.0801Z",
    fill: "#0089EC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgObjectBusMinor);
export default __webpack_public_path__ + "static/media/object-bus-minor.2098904a057c8448a83be3126603a252.svg";
export { ForwardRef as ReactComponent };